import React from 'react';
import { Avatar as UserAvatar } from '@gravity-ui/uikit';

const STAFF_URL = 'https://staff.yandex-team.ru/';

type UserLogoProps = {
    avatar: string;
};
export function UserLogo({ avatar }: UserLogoProps) {
    return (
        <a href={STAFF_URL} className="Header-user-staff-link" target="_blank">
            <UserAvatar imgUrl={avatar} size={'l'} className="Header-user-avatar" />
        </a>
    );
}
